import { z } from 'zod'
/**
 * Zod coerce.boolean acts simply. It pipes the value throught the Boolean() constructor, so "false" will be true.
 * We should allow to use "0", "false" as falsy and "1", "true" as truthy values!
 */
export const booleanEnvironmentSchema = () =>
  z
    .enum(['0', '1', 'true', 'false', ''])
    .transform((value) => value === 'true' || value === '1')
    .default('false')
    .or(z.boolean().default(false))
    .or(z.number().transform((value) => value === 1))

export const requiredNumberEnvironment = (message = 'Required') =>
  z.preprocess(
    (value) =>
      value === '' || value === undefined || value === null
        ? undefined
        : Number(value),
    z.number({
      required_error: message,
      invalid_type_error: 'Must be a number',
    }),
  )
